import { buttonClasses } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { MetricGroupType } from "./MetricsTableMetricsFilterButtonGroup.types";

export const METRIC_GROUP_TYPE_ALL = "all" as const satisfies MetricGroupType;

export const METRIC_GROUPS: MetricGroupType[] = [
  "resources",
  "time",
  "schema",
  "distribution",
  "volume",
];

export const buttonGroupStyles: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
  gridAutoFlow: "column",
  width: "100%",
  minWidth: 0,
  minHeight: 32,
  border: "1px solid",
  borderColor:
    "light-dark(var(--mui-palette-neutral-light), var(--mui-palette-neutral-dark))",

  [`& .${buttonClasses.root}`]: {
    backgroundColor: "background.paper",
    lineHeight: ".75",
    textTransform: "none",
    borderColor:
      "light-dark(var(--mui-palette-neutral-light), var(--mui-palette-neutral-dark))",
    color: "light-dark(var(--mui-palette-grey-500), var(--mui-palette-grey-400))",
    justifyContent: "space-between",
    paddingLeft: 1.5,
    paddingRight: 0.75,
    textAlign: "left",
    gap: 0.5,
    minWidth: 0,
    width: "100%",

    "&.selected": {
      backgroundColor: "var(--mui-palette-primary-lightest)",
    },
  },
};
